import { F } from "../../theme/tokens";

// ── Small reusable atoms ──────────────────────────────────────────────────────

export function Avatar({ initials, color, size = 36, className }: { initials: string; color: string; size?: number; className?: string }) {
  return (
    <div className={className} style={{ width: size, height: size, borderRadius: "50%", background: color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <span style={{ fontSize: size * 0.33, fontWeight: 700, color: "#fff", fontFamily: F }}>{initials}</span>
    </div>
  );
}

export function OrgAvatar({ initials, color, size = 36, className }: { initials: string; color: string; size?: number; className?: string }) {
  return (
    <div className={className} style={{ width: size, height: size, borderRadius: "8px", background: color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
      <span style={{ fontSize: size * 0.33, fontWeight: 700, color: "#fff", fontFamily: F }}>{initials}</span>
    </div>
  );
}
